import { useNetwork } from '@vueuse/core';
const {
  isOnline,
  offlineAt,
  downlink,
  downlinkMax,
  effectiveType,
  saveData,
  type,
} = useNetwork();
import { useData } from '../store';
const { init_data } = useData();
// 加载一个脚本
import { useStore } from '../store';
const { channel, ua_info } = useStore();
function addNetWork(data) {
  data.network = {
    isOnline: isOnline.value,
    downlink: downlink.value,
    effectiveType: effectiveType.value,
    type: type.value,
    offlineAt: offlineAt.value,
    downlinkMax: downlinkMax.value,
    saveData: saveData.value,
  };
  return data;
}

function addName(data) {
  data.activity = import.meta.env.VITE_NAME;
  return data;
}

// vue相关报错
export default function (data) {
  data = addName(data);
  if (data.isNetWork) {
    data = addNetWork(data);
  }
  console.error('注意！', data);
  if (!import.meta.env.PROD) return;
  data.ua = ua_info;
  if (import.meta.env.PROD) {
    fetch(`${import.meta.env.VITE_BASEAPI}/common/record_frontend_log`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}

export function logNoUa(data) {
  data = addName(data);
  if (data.isNetWork) {
    data = addNetWork(data);
  }
  // console.log('报错了', data);
  // if (import.meta.env.PROD) {
  //   fetch(`${import.meta.env.VITE_BASEAPI}/common/record_frontend_log`, {
  //     method: 'POST',
  //     body: JSON.stringify(data),
  //   });
  // }
}

// 首次访问页面后调用
export function firstLog(isLogin) {
  const headers = new Headers({});
  if (channel.utm_source == 'gw' && channel.extra == 'gw') {
    headers.set('Tx-Platform', channel.utm_source);
  }
  if (channel.extra !== 'gw') {
    headers.set('Tx-Platform', channel.extra);
  }
  if (channel.utm_source !== 'gw') {
    headers.set('Tx-Platform', channel.utm_source);
  }

  let data = new FormData();
  data.append('activity', import.meta.env.VITE_NAME);
  data.append('op_code', 'login');
  data.append(
    'details',
    JSON.stringify({ page_name: 'home', event_type: 'onLoad' })
  );
  data.append('server_group', '');
  data.append('channel', channel.channel);
  if (isLogin) {
    if (Object.keys(init_data.account_data).length) {
      data.append('role_name', '');
      data.append('role_id', '');
      data.append('server_id', '');
    }
    data.append('account_id', init_data.account_data.username);
  } else {
    data.append('role_name', ' ');
    data.append('role_id', ' ');
    data.append('server_id', ' ');
    data.append('account_id', ' ');
  }
  data.append('h5user_id', window.figureCode);
  fetch(`${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log `, {
    method: 'POST',
    body: data,
    headers: headers,
  });
}

// 登录成功后调用
export function loginSuccessLog(account) {
  const headers = new Headers({});
  if (channel.utm_source == 'gw' && channel.extra == 'gw') {
    headers.set('Tx-Platform', channel.utm_source);
  }
  if (channel.extra !== 'gw') {
    headers.set('Tx-Platform', channel.extra);
  }
  if (channel.utm_source !== 'gw') {
    headers.set('Tx-Platform', channel.utm_source);
  }

  let data = new FormData();
  data.append('activity', import.meta.env.VITE_NAME);
  data.append('op_code', 'login');
  data.append(
    'details',
    JSON.stringify({ page_name: 'home', event_type: 'onLogin' })
  );
  data.append('server_group', '');
  data.append('channel', channel.channel);
  data.append('role_name', ' ');
  data.append('role_id', ' ');
  data.append('server_id', ' ');
  data.append('account_id', init_data.account_data.username);
  data.append('h5user_id', window.figureCode);
  fetch(`${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log`, {
    method: 'POST',
    body: data,
    headers: headers,
  });
}

// 绑定成功后调用
export function bindRoleSuccessLog() {
  const headers = new Headers({});
  if (channel.utm_source == 'gw' && channel.extra == 'gw') {
    headers.set('Tx-Platform', channel.utm_source);
  }
  if (channel.extra !== 'gw') {
    headers.set('Tx-Platform', channel.extra);
  }
  if (channel.utm_source !== 'gw') {
    headers.set('Tx-Platform', channel.utm_source);
  }

  let data = new FormData();
  data.append('activity', import.meta.env.VITE_NAME);
  data.append('op_code', 'login');
  data.append(
    'details',
    JSON.stringify({ page_name: 'home', event_type: 'onBindRole' })
  );
  data.append('server_group', import.meta.env.VITE_TEAM == 'tx2' ? 2 : 1);
  data.append('channel', channel.channel);
  data.append('role_name', init_data.role_info.role_name);
  data.append('role_id', init_data.role_info.role_id);
  data.append('server_id', init_data.role_info.server_id);
  data.append('account_id', init_data.account_data.username);
  data.append('h5user_id', window.figureCode);
  fetch(`${import.meta.env.VITE_BASEAPI}/tx3/us/collect_log `, {
    method: 'POST',
    body: data,
    headers: headers,
  });
}
